/** Matches GraphQL enum CategoryItemsActiveFilter */
export type MenuListActiveFilter = "ACTIVE" | "INACTIVE" | "ALL";

export const MENU_LIST_FILTER_TABS: { id: MenuListActiveFilter; label: string }[] = [
  { id: "ACTIVE", label: "Active" },
  { id: "INACTIVE", label: "Inactive" },
  { id: "ALL", label: "All" },
];
